<template>
  <div>
    <Head title="Price Lists" />
    <h1 class="mb-8 text-3xl font-bold">Price Lists</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Deleted:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Exclude Deleted</option>
          <option value="with">Include Deleted</option>
          <option value="only">Only Deleted</option>
        </select>
      </search-filter>
      <Link class="btn-blue" href="/pricelists/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Price List</span>
      </Link>
    </div>
    <div class="bg-white  shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6 text-center">Discounts</th>
            <th class="pb-4 pt-6 px-6 text-center">Companies</th>
            <th class="pb-4 pt-6 px-6 text-center">Channels</th>
            <th class="pb-4 pt-6 px-6 text-center">Grates</th>
            <th class="pb-4 pt-6 px-6 text-center" colspan="2">Accessories</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pricelist in pricelists.data" :key="pricelist.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/pricelists/${pricelist.id}/edit`">
                {{ pricelist.name }}
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500 justify-center" :href="`/pricelists/${pricelist.id}/edit`">
                <span span class="rounded-full bg-gray-200 py-1 px-2">{{ pricelist.discounts_count }}</span>
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500 justify-center" :href="`/pricelists/${pricelist.id}/edit`">
                <span class="rounded-full bg-gray-200 py-1 px-2">{{ pricelist.companies_count }}</span>
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t text-center">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500 justify-center" :href="`/pricelists/${pricelist.id}/edit`">
                <span class="rounded-full bg-gray-200 py-1 px-2">{{ pricelist.channels_count }}</span>
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t text-center">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500 justify-center" :href="`/pricelists/${pricelist.id}/edit`">
                <span class="rounded-full bg-gray-200 py-1 px-2">{{ pricelist.grates_count }}</span>
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t text-center">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500 justify-center" :href="`/pricelists/${pricelist.id}/edit`">
                <span class="rounded-full bg-gray-200 py-1 px-2">{{ pricelist.accessories_count }}</span>
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/pricelists/${pricelist.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="pricelists.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No pricelists found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="pricelists.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    pricelists: Object,
  },
  data() {
    return {
      form: {
        search : this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/pricelists', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
